import React from 'react';
import { Box, Container, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import RegisterForm from '../components/auth/RegisterForm';

const Register = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const boxBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Box bg={bgColor} minH='100vh' py={12}>
      <Container maxW='lg'>
        <VStack spacing={8}>
          <VStack spacing={2} textAlign='center'>
            <Heading fontSize='4xl'>Create an Account</Heading>
            <Text fontSize='lg' color='gray.600'>
              Get started with dwelz today
            </Text>
          </VStack>

          <Box w='100%' bg={boxBgColor} borderRadius='lg' p={8} boxShadow='lg'>
            <RegisterForm />
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default Register;
